import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { APP_CONTROLLER_REDUCERS } from '@bitComponents/unifiedComponents/AppController';
import InitReducer from './init';
import AddressReducer from './address';
import ApisNeedsReducer from './apisNeeds';
import UINeedsReducer from './uiNeeds';
import LoaderControlReducer from './loaderControl';
import FlowReducer from './flow';
import SummaryInfoReducer from './summaryInfo';
import OfferReducer from './offer';
import TaggingReducer from './tagging';
import NextStepsReducer from './nextSteps';
import ErrorManagementReducer from './errorManagement';
import LocalizedStringsReducer from './localizedStrings';
import PinReducer from './pin';
import OBDReducer from './obd';
import SEReducer from './se';
import ManualReducer from './manual';

const rootReducers = history => combineReducers({
  router: connectRouter(history),
  context: APP_CONTROLLER_REDUCERS.context,
  errorCatcher: APP_CONTROLLER_REDUCERS.errorCatcher,
  address: AddressReducer,
  apiNeeds: ApisNeedsReducer,
  errorManagement: ErrorManagementReducer,
  flow: FlowReducer,
  init: InitReducer,
  loaderState: LoaderControlReducer,
  localizedStrings: LocalizedStringsReducer,
  manual: ManualReducer,
  nextSteps: NextStepsReducer,
  obd: OBDReducer,
  offer: OfferReducer,
  pin: PinReducer,
  se: SEReducer,
  summaryInfo: SummaryInfoReducer,
  tagging: TaggingReducer,
  uiNeeds: UINeedsReducer,
});


export default rootReducers;
